export default {"src":"/_next/static/media/icon-enerflo-docflo-document-change-orders.997a223d.svg","height":128,"width":128};